module.exports = __webpack_public_path__ + "static/media/audotask.826aa4d1.png";